import * as Const from '../constants/actionConstants';

import State from '../interfaces/states/SubToasterState';

const initState: State = {
  messages: [],
  tokenUpdateStatus: false,
};

export default function subToaster (state: State = initState, action): State {
  switch (action.type) {

    case Const.TOASTER_TOKEN_IS_UPDATING:
      return changeTokenUpdateStatus(state, action.status);

    case Const.TOASTER_ADD_MESSAGE:
      return pushMessage(state, action.message);

    case Const.TOASTER_DELETE_MESSAGE:
      return deleteMessage(state, action.id);
    default:
      return state;
  }
}

const pushMessage = (state, message) => {
  return {
    ...state,
    messages: [...state.messages, message],
  };
};

const deleteMessage = (state, id) => {
  return {
    ...state,
    messages: state
      .messages.
      filter(message => message.id !== id),
  };
};

const changeTokenUpdateStatus = (state, status) => {
  return {
    ...state,
    tokenUpdateStatus: status,
  };
};
